import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sheet", "backdrop"]

  open() {
    this.sheetTarget.classList.remove("hidden")
    this.backdropTarget.classList.remove("hidden")
    
    // reflow
    void this.element.offsetWidth
    
    this.backdropTarget.classList.remove("opacity-0")
    this.sheetTarget.classList.remove("translate-y-full")
  }

  close() {
    this.backdropTarget.classList.add("opacity-0")
    this.sheetTarget.classList.add("translate-y-full")
    
    setTimeout(() => {
      this.sheetTarget.classList.add("hidden")
      this.backdropTarget.classList.add("hidden")
    }, 300)
  }
}
